<template>
  <div class="page">
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="normal pointer" @click="toList()">报工列表</span>
      <span class="normal space">/</span>
      <span class="active">报工详情</span>
    </div>
    <div class="content">
      <div class="title">
        <h2>
          报工详情
          <span
            class="tag"
            :class="['tag' + dataSource.ssoSupplierOrderStatus]"
            v-if="dataSource.ssoSupplierOrderStatusStr"
            >{{ dataSource.ssoSupplierOrderStatusStr }}</span
          >
        </h2>
        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">提交人:</div>
            <div class="value">{{ dataSource.name || "-" }}</div>
          </div>
          <div class="info-item inline-item">
            <div class="label">提交时间:</div>
            <div class="value">{{ dataSource.submitTime || "-" }}</div>
          </div>
        </div>
        <div>
          <!-- 未提交:2 已提交:1 时显示 -->
          <el-button
            v-if="[2].includes(+dataSource.ssoSupplierOrderStatus)"
            type="primary"
            size="small"
            @click="onSubmit()"
            >提交</el-button
          >
          <el-button
            v-if="[1, 2].includes(+dataSource.ssoSupplierOrderStatus)"
            plain
            size="small"
            @click="onEdit()"
            >编辑</el-button
          >
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <div>
          <div class="info-item">
            <div class="label">项目名称:</div>
            <div class="value">
              {{ dataSource.projectName || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">申请单号:</div>
            <div class="value">
              {{ dataSource.demandTableNo || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">项目经理:</div>
            <div class="value">
              {{ dataSource.projectManager || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">装置名称:</div>
            <div class="value">
              {{ dataSource.deviceName || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">工作内容:</div>
            <div class="value">
              {{ dataSource.workDescription || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">工作状态:</div>
            <div class="value">
              {{ dataSource.workStatusStr || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">工时(小时):</div>
            <div class="value">
              {{ dataSource.deliveryNum || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">填报日期:</div>
            <div class="value">
              {{ dataSource.supplierOrderCreateTime || "-" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      dataSource: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDataSource();
  },
  methods: {
    onEdit() {
      this.$router.push({
        name: "ecologicalServices-report-edit",
        query: { id: this.id },
      });
    },
    onSubmit() {
      this.$http
        .post(`/front/oms/sso/supplier/order/submit?id=${this.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success("提交成功");
            // 刷新数据
            this.getDataSource();
          }
        });
    },
    getDataSource() {
      this.$http
        .get(`/front/oms/sso/supplier/order/supplierOrderDetail/${this.id}`)
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            this.dataSource = data;
          }
        });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
    toList() {
      this.$router.push({ name: "ecologicalServices-report-list" });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
}

.path {
  height: 36px;
  line-height: 36px;

  .normal {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #999999;
  }

  .active {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }

  .space {
    margin-right: 8px;
    margin-left: 8px;
  }
}

.content {
  background: #fff;
  padding: 20px;
  min-height: 800px;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 0;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;

  &:hover {
    opacity: 0.9;
  }
}

.title {
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.label {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  text-align: right;
  color: #666666;
  padding-right: 8px;
  width: 100px;
}

.value {
  flex: 1;
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

.flex {
  display: flex;
}

.info-item {
  display: flex;
  margin-bottom: 20px;

  a {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    color: #2a54d1;
  }
}

.mb-16 {
  margin-bottom: 16px;
}

.bold-tag {
  border-radius: 4px;
  padding: 6.5px 18px;
  background: #2a54d1;
  display: inline-block;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  color: #ffffff;
}

.inline-item {
  width: 300px;
}

.tag {
  border-radius: 14px;
  padding: 2px 8px;

  font-family: Alibaba PuHuiTi;
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  margin-left: 12px;
}

.tag3 {
  background: #2a54d1;
}

.tag2 {
  background: #e5a92f;
}

.tag1 {
  background: #1fbd13;
}

.pointer {
  cursor: pointer;
}

.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
